import { Appender, LogLevel, LogEvent } from "@blacknut/logging/dist";
import sprintf from "sprintf-js";
import { StatusType, Logger } from "@datadog/browser-logs";
import { datadogLogs } from "@datadog/browser-logs";
import datadog from "..";
const LevelTypeStr: Record<LogLevel, string> = {
  [LogLevel.LEVEL_ERROR]: "error",
  [LogLevel.LEVEL_WARN]: "warn",
  [LogLevel.LEVEL_INFO]: "info",
  [LogLevel.LEVEL_DEBUG]: "debug",
};
const addLoggerProperty = (logger: Logger, key: string, value?: string) => {
  if (value) {
    logger.setContextProperty(key, value);
  } else {
    logger.removeContextProperty(key);
  }
};
export class DDAppender extends Appender {
  constructor(opts?: { type?: string }) {
    super();
    const { type = "webrtc-sdk" } = opts || {};
    datadogLogs.logger.setContext({ type });
    datadogLogs.logger.setLevel(
      LevelTypeStr[this._level || LogLevel.LEVEL_INFO] as StatusType
    );
  }

  public set level(v: LogLevel | undefined) {
    super.level = v;
    datadogLogs.logger.setLevel(
      LevelTypeStr[this._level || LogLevel.LEVEL_INFO] as StatusType
    );
    for (const [, logger] of this.loggerCache) {
      logger.setLevel(
        LevelTypeStr[this._level || LogLevel.LEVEL_INFO] as StatusType
      );
    }
  }

  private _userId: string | undefined;
  public get userId(): string | undefined {
    return this._userId;
  }
  public set userId(v: string | undefined) {
    this._userId = v;
    this.loggerCache.forEach((value) => {
      addLoggerProperty(value!, "user", v);
    });

    addLoggerProperty(datadogLogs.logger, "user", v);
  }

  private loggerCache: Map<string, Logger> = new Map();
  private getOrCreateLogger = (tag: string) => {
    let res = this.loggerCache.get(tag);
    if (res) {
      return res;
    }
    res = datadogLogs.createLogger(tag, {
      level: datadogLogs.logger.getLevel(),
      handler: datadogLogs.logger.getHandler(),
      context: {
        ...datadogLogs.logger.getContext(),
        logger: { name: tag },
      },
    });
    this.loggerCache.set(tag, res);
    return res;
  };

  append(e: LogEvent) {
    const logger = e.tag ? this.getOrCreateLogger(e.tag) : datadog.logger;
    const levelStr = LevelTypeStr[e.level];
    const levelUp = LevelTypeStr[e.level].toUpperCase();
    const formattedDate = e.time
      .toTimeString()
      .replace(/.*(\d{2}:\d{2}:\d{2}).*/, "$1");
    const prefix = `[${formattedDate}] [${levelUp}]`;
    const formattedMessage = sprintf.sprintf(
      `${prefix} ${e.message.replace(/%o/g, "%j")}`,
      ...e.args
    );
    logger.log(
      formattedMessage,
      {
        level: levelStr,
      },
      levelStr as StatusType
    );
  }
}
